import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';

export default function BasicTable({rows}) {
  return (
    <TableContainer className='scrollBar' sx={{height:'100%'}} component={Paper}>
      <Table sx={{ minWidth: 350}} aria-label="simple table">
        <colgroup>
            <col className='param-table-column'/>
            <col className='param-table-column'/>
            <col style={{width:'20%'}}/>
        </colgroup>
        <TableHead className='table-header'>
          <TableRow>
            <TableCell align="left" sx={{paddingTop: 1, paddingBottom: 0.5,backgroundColor:'#f2f2f2'}} >Name</TableCell>
            <TableCell align="left" sx={{paddingTop: 1, paddingBottom: 0.5,backgroundColor:'#f2f2f2'}} >Description</TableCell>
            <TableCell align="left" sx={{paddingTop: 1, paddingBottom: 0.5,backgroundColor:'#f2f2f2'}} >isOptional</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 }}}
            >
              <TableCell align="left" sx={{paddingTop: 0.8, paddingBottom: 0.2}} >{row.name}</TableCell>
              <TableCell align="left" sx={{paddingTop: 0.8, paddingBottom: 0.2}}>{row.desc}</TableCell>
              <TableCell align="left" sx={{paddingTop: 0.8, paddingBottom: 0.2}}>{!row.isOptional  ? <HighlightOffOutlinedIcon/> : <CheckOutlinedIcon />}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
